// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__31i9u","button":"Toast_button__sfLGO"};